import { USERS, PROPERTIES } from '../../firebase';
import FormUIOptions from '../components/formBuilder/formElements/formUIOptions';
import { isValue } from '../utility/isValue';

const parkingOptions = [
  { label: 'None', layout: 'default', value: 'None' },
  {
    label: 'Garage',
    layout: 'default',
    value: 'Garage',
  },
  { label: 'Car Port', layout: 'default', value: 'Car Port' },
  { label: 'Private Lot', layout: 'default', value: 'Private Lot' },
  { label: 'Off-street', layout: 'default', value: 'Off-street' },
  { label: 'On-street', layout: 'default', value: 'On-street' },
];

const propertyTypes = [
  {
    label: 'Single-family',
    layout: 'default',
    value: 'single-family',
  },
  {
    label: 'Duplex',
    layout: 'default',
    value: 'duplex',
  },
  {
    label: 'Apartment building',
    layout: 'default',
    value: 'apartment-building',
  },
  {
    label: 'Commercial',
    layout: 'default',
    value: 'commercial',
  },
  {
    label: 'Mixed use',
    layout: 'default',
    value: 'mixed-use',
  },
  {
    label: 'Cottage rental',
    layout: 'default',
    value: 'cottage-rental',
  },
  {
    label: 'Multi-residential',
    layout: 'default',
    value: 'multi-residential',
  },
  {
    label: 'Other',
    layout: 'default',
    value: 'other',
  },
];

export default {
  messageOnFinish: 'Proceed to the next step to explore BRRRR Scenario',
  pathToSource: [
    {
      type: 'collection',
      value: USERS,
    },
    {
      type: 'user',
      value: 'uid',
    },
    {
      type: 'collection',
      value: PROPERTIES,
    },
    {
      type: 'param',
      value: 'propertyId',
    },
  ],
  inputs: {
    title: 'Property Details',
    description: 'Add details about the property you are analyzing.',
    submitButtonDescription: 'Submit the form to update your property details.',
    schema: [
      {
        sectionLabel: 'Property Details',
        sectionValue: 'propertyDetails',
        sectionDescription: 'Optional details about your property.',
        sectionCollapsed: true,
        schema: [
          {
            type: FormUIOptions.Place,
            label: 'Property Address',
            layout: 'default',
            name: 'propertyAddress',
          },
          {
            type: FormUIOptions.Text,
            label: 'Property Name',
            layout: 'default',
            description:
              'Provide an optional property name that will be included in shared reports',
            name: 'propertyName',
          },
          {
            type: FormUIOptions.TextArea,
            label: 'Property Description',
            layout: 'default',
            name: 'description',
            description: 'Provide an optional description for the property',
          },
          {
            type: FormUIOptions.Select,
            label: 'Property Type',
            layout: 'default',
            name: 'propertyType',
            options: propertyTypes,
          },
          {
            type: FormUIOptions.Text,
            label: 'Other Property Type',
            layout: 'default',
            name: 'propertyTypeOther',
            condition: {
              field: 'propertyType',
              isLocal: true,
              value: 'other',
            },
          },
          {
            type: FormUIOptions.Text,
            label: 'Year Built',
            layout: 'default',
            name: 'yearBuilt',
          },
          {
            type: FormUIOptions.Number,
            label: 'Units',
            groupStart: true,
            layout: 'default',
            name: 'unitsPropertyDetails',
            unit: 'units',
          },

          {
            type: FormUIOptions.Number,
            label: 'Bedrooms',
            layout: 'default',
            name: 'bedroomsPropertyDetails',
            unit: 'bedrooms',
          },
          {
            type: FormUIOptions.Number,
            label: 'Bathrooms',
            layout: 'default',
            name: 'bathroomsPropertyDetails',
            unit: 'bathrooms',
          },
          {
            type: FormUIOptions.Select,
            label: 'Parking',
            layout: 'default',
            name: 'parkingPropertyDetails',
            options: parkingOptions,
          },

          {
            type: FormUIOptions.Number,
            label: 'Square Feet',
            groupStart: true,
            layout: 'default',
            name: 'squareFootage',
            unit: 'sq ft',
          },

          {
            type: FormUIOptions.Number,
            label: 'Lot Size',
            layout: 'default',
            name: 'lotSizeSquareFootage',
            unit: 'sq ft',
          },
          {
            type: FormUIOptions.Text,
            label: 'Zoning Type',
            layout: 'default',
            name: 'zoningType',
          },
          {
            type: FormUIOptions.Text,
            label: 'MLS Number',
            layout: 'default',
            name: 'mlsNumber',
          },
        ],
      },

      {
        sectionLabel: 'Additional Information',
        sectionValue: 'additionalInformation',
        sectionDescription:
          'Optional additional information about your property',
        sectionCollapsed: true,
        schema: [
          {
            type: FormUIOptions.TextArea,
            label: 'Project Plan',
            name: 'projectPlan',
            layout: 'default',
          },
          {
            type: FormUIOptions.TextArea,
            label: 'Additional Notes',
            name: 'additionalNotes',
            layout: 'default',
          },
        ],
      },
    ],
  },
  //this is not displayed but used to calculate a specific value
  calculations: {
    title: 'Property Summary',
    description: 'Summary of your property details on purchase',
    schema: [
      //wip
      {
        sectionType: 'chart',
        sectionValue: 'propertyDetails',
        schema: [
          {
            type: FormUIOptions.Number,
            label: 'Country',
            name: 'propertyInCanada',
            layout: 'default',
            derivedFrom: ['propertyAddress', 'propertyInCanada'],
            calcFunction: (address, propertyInCanada) => {
              if (!Array.isArray(address) || !address.length)
                return isValue(propertyInCanada) ? propertyInCanada : 1;

              for (let segment of address) {
                if (segment.types.includes('country')) {
                  if (segment.short_name === 'CA') {
                    return 1;
                  } else {
                    return 0;
                  }
                }
              }
            },
          },
        ],
      },
    ],
  },
};
